import TaskIcon from '@plato/ui-legacy/assets/icons/task-icon';
import { DropdownMenuItem } from '@plato/ui/containers/dropdown-menu';
import { MenuItemLabel, MenuItemLeading } from '@plato/ui/primitives/menu';
import { useTranslation } from 'react-i18next';
import type { CrmTaskDTO } from '../../../server/dto/crm-task-dto.ts';
import type { TaskCreatedSource } from '../../analytics/types/analytics-events.ts';
import { useShowCreateTaskDialog } from '../hooks/use-show-create-task-dialog.ts';

export type TaskLinks = Pick<CrmTaskDTO['links'][0], 'modelId' | 'modelType' | 'title'>[];

type DropdownMenuItemCreateTaskProps = {
    links: TaskLinks;
    source: TaskCreatedSource;
};

export function DropdownMenuItemCreateTask({ links, source }: DropdownMenuItemCreateTaskProps) {
    const { t } = useTranslation();
    const showCreateTaskDialog = useShowCreateTaskDialog();

    return (
        <DropdownMenuItem
            onClick={() => {
                showCreateTaskDialog({ links, source });
            }}
        >
            <MenuItemLeading>
                <TaskIcon />
            </MenuItemLeading>
            <MenuItemLabel>{t('customer_detail__header__task', { ns: 'customer-detail' })}</MenuItemLabel>
        </DropdownMenuItem>
    );
}
